<template>
  <div>
    <GameSkeleton v-if="!isMountedMainComponent || isFetching " />

    <div v-show="isMountedMainComponent && !isFetching " class="page-game">
      <GameHeader />
      <div class="page-game__container">
        <GameControls
          v-if="$device.isDesktop"
          @full-screen="isFullScreen = $event"
        />
        <TheGame v-onmount="() => isMountedMainComponent = true" class="page-game__the-game" :full-screen="isFullScreen" />

        <SeoPageContent
          v-if="!isServerToken && !isLoggedIn"
          class="page-game__seo"
        />
      </div>

      <ClientOnly>
        <LimitsModalGamePause />
      </ClientOnly>

      <ClientOnly>
        <LimitsModalExceeded />
      </ClientOnly>

      <SeoTemplate
        :seo-title="get_seoPage.title"
        :seo-description="get_seoPage.description"
        :og-img-url="gameImage ? gameImage : ''"
        :twitter-img-url="gameImage ? gameImage : ''"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
/** Components */
import { exitFullScreen } from '~/util/browser'
import { jsonldArticle } from '~/util/helpers/jsonldHelper'
import GameSkeleton from '~/components/Game/Skeleton'

export default {
  name: 'GamePage',
  components: {
    GameSkeleton,
    SeoPageContent: () => import('~/components/shared/SeoPageContent/index'),
    SeoTemplate: () => import('~/components/shared/SeoTemplate/index'),
    GameControls: () => import('~/components/Game/GameControls'),
    GameHeader: () => import('~/components/Game/GameHeader'),
    TheGame: () => import('~/components/Game/TheGame'),
    BaseModalLocal: () => import('~/components/Base/Modal/Local'),
    LimitsModalExceeded: () => import('@/components/Limits/Modal/LimitsModalExceeded'),
    LimitsModalGamePause: () => import('@/components/Limits/Modal/LimitsModalGamePause'),
  },
  beforeRouteLeave(_, __, next) {
    if (this.isFullScreen) exitFullScreen()
    next()
  },
  layout: 'game',
  jsonld() {
    return jsonldArticle(this.$config.cloudUrl, this.get_seoPage, this.$route.path)
  },
  data() {
    return {
      isFullScreen: false,
      isFetching: false,
    }
  },
  async fetch() {
    this.isFetching = true
    const promises = []
    promises.push(this.fetchSeo())
    promises.push(this.isLoggedIn
      ? this.fetch_promotionProgress()
      : this.fetchGame()
    )
    await Promise.all(promises)

    this.isFetching =false
  },

  computed: {
    ...mapGetters('seo', ['get_seoPage']),
    ...mapGetters('game', ['get_game']),
    ...mapGetters('user', ['isLoggedIn', 'user', 'isUserLoaded']),
    ...mapGetters('base', ['isServerToken']),
    term() {
      return this.$route.params.term
    },
    gameImage() {
      return this.get_game.data.iconUrlVertical ? this.get_game.data.iconUrlVertical : '/img/seo/lobby/slots-games_1200_630.jpg'
    },
  },
  watch: {
    'get_game.data'() {
      this.checkAuthRequired()
    },
    isUserLoaded() {
      if (!this.isUserLoaded) return
      this.fetchGame()
      this.fetch_promotionProgress()
    },
  },
  created() {
    if (this.isLoggedIn && this.isUserLoaded) this.fetchGame()
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
    this.checkAuthRequired()
  },
  methods: {
    ...mapActions('game', ['fetch_game']),
    ...mapActions('seo', ['fetch_seoPage']),
    ...mapActions('promotions', ['fetch_promotionProgress']),
    async fetchSeo() {
      await this.fetch_seoPage(this.$route.path)
    },
    async fetchGame() {
      await this.fetch_game({ isLoggedIn: this.isLoggedIn, term: this.term })
    },
    checkAuthRequired() {
      if (this.get_game.data.code === 'AUTH_REQUIRED' && !this.isLoggedIn) {
        this.$router.push({ path: this.$paths.live })
        setTimeout(()=>{
          this.$newModal.openAuthOrRegister()
        },100)
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
